import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as IconLocation } from '../../../../assets/images/location.svg';
import { ReactComponent as IconSearch } from '../../../../assets/images/search-in-square.svg';
import { getCurrentPosition } from '../../../../store/location';
import { loadersByName } from '../../../../store/ui';
import { useMedia } from '../../../context/InterfaceContext';
import Button, { ButtonKind } from '../button/Button';
import './index.scss';

const DefaultMessage = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const loaderLocation = useSelector(loadersByName('location'));
    const loaderSearch = useSelector(loadersByName('searchNearMe'));
    const { isFullMobile } = useMedia();

    return (
        <div className="not-search-result__wrapper">
            <div className="not-search-result default-message">
                <IconSearch />
                <h3>
                    {intl.formatMessage({
                        id: 'location.notSearchResult.defaultTitle',
                        defaultMessage: 'Entdecken Sie unser breites Produktangebot',
                    })}
                </h3>

                <h5>
                    {intl.formatMessage({
                        id: 'location.notSearchResult.defaultSubTitle',
                        defaultMessage: "Und so einfach geht's",
                    })}
                </h5>

                <p>
                    {intl.formatMessage(
                        {
                            id: 'location.notSearchResult.defaultSDescription',
                            defaultMessage:
                                'Geben Sie dazu oben im Suchfeld Ort, PLZ oder Produkte-Id (id:123456) ein und verfeinern Sie, wenn gewünscht, das Suchresultat mit den nebenstehenden Filtermöglichkeiten.{br}{br}Der Product Finder wird in den nächsten Wochen stetig mit weiteren Produkten der APG|SGA angereichert.',
                        },
                        { br: <br /> }
                    )}
                </p>

                <p>
                    {intl.formatMessage({
                        id: 'location.notSearchResult.defaultSubDescription',
                        defaultMessage: 'Tauchen Sie jetzt in die Produktwelt der APG|SGA ein!',
                    })}
                </p>

                <Button
                    className={'search-filter__search--near-me-btn'}
                    kind={ButtonKind.LINK}
                    onClick={() => dispatch(getCurrentPosition())}
                    disabled={loaderSearch || loaderLocation}
                >
                    <IconLocation style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                    {!isFullMobile &&
                        (loaderSearch
                            ? intl.formatMessage({ id: 'general.loading', defaultMessage: 'Wird geladen...' })
                            : intl.formatMessage({ id: 'searchFilter.nearBtn', defaultMessage: 'in meiner Nähe' }))}
                </Button>
            </div>
        </div>
    );
};

export default DefaultMessage;
